import { useToast } from './use-toast';
import { cn } from '@/shared/utils';
import { X, CheckCircle2, AlertCircle, Info } from 'lucide-react';

const variantStyles = {
  default: 'border bg-background text-foreground',
  destructive: 'border-destructive/50 bg-destructive/10 text-destructive dark:text-red-400',
  success: 'border-green-500/50 bg-green-50 text-green-800 dark:bg-green-950/30 dark:text-green-400',
};

const variantIcons = {
  default: <Info className="h-4 w-4 shrink-0" />,
  destructive: <AlertCircle className="h-4 w-4 shrink-0" />,
  success: <CheckCircle2 className="h-4 w-4 shrink-0" />,
};

export default function Toaster() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-full max-w-sm pointer-events-none">
      {toasts.map((t) => {
        const variant = t.variant ?? 'default';
        return (
          <div
            key={t.id}
            className={cn(
              'pointer-events-auto rounded-lg border p-4 shadow-lg animate-in slide-in-from-bottom-5 fade-in-0 duration-200',
              variantStyles[variant],
            )}
            role="status"
            aria-live="polite"
          >
            <div className="flex items-start gap-3">
              {variantIcons[variant]}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold">{t.title}</p>
                {t.description && (
                  <p className="text-sm opacity-80 mt-0.5">{t.description}</p>
                )}
              </div>
              <button
                onClick={() => dismiss(t.id)}
                className="shrink-0 rounded-md p-1 opacity-70 hover:opacity-100 transition-opacity"
                aria-label="Dismiss"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
